import script from "./SoundWave.vue?vue&type=script&setup=true&lang=js"
export * from "./SoundWave.vue?vue&type=script&setup=true&lang=js"

import "./SoundWave.vue?vue&type=style&index=0&id=7d387dd0&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d387dd0"]])

export default __exports__